import { render, staticRenderFns } from "./c_hot_word.vue?vue&type=template&id=e5dd5998&scoped=true&"
import script from "./c_hot_word.vue?vue&type=script&lang=js&"
export * from "./c_hot_word.vue?vue&type=script&lang=js&"
import style0 from "./c_hot_word.vue?vue&type=style&index=0&id=e5dd5998&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dd5998",
  null
  
)

export default component.exports